import { OfferCodeInputVariables } from '@sparrow-card/sparrow-card-constants';
import { validateZip } from 'components/Input/templates';
import { getIsRequiredMessage } from 'utils/error';

export const OFFER_CODE_ZIP_RULES = {
  required: {
    value: true,
    message: getIsRequiredMessage(OfferCodeInputVariables.ZipCode),
  },
  validate: validateZip,
};
